<template>
    <div class="custom-form">
        <div class="field-item-wrap" v-for="(f, index) in fields" :key="index">
            <component :is="f.type" :ref="`field_${index}`"  :field.sync="f"></component>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
import richTextForm from './richTextForm';
import imageList from './imageList';
import textBox from './textBox';
import colorPicker from './colorPicker';
import itemList from './itemList';
import numberInput from './numberInput';
import channelDis from './channelDis';
import uploadImage from './uploadImage';
import treeList from './treeList';
import jsonEditor from './jsonEditor';

export default {
    name: 'custom-form',
    props: ['fields'],
    data() {
        return {
            // fields: {},
            isDestroy: false
        }
    },
    components: {
        'image_list': imageList,
        'rich_text': richTextForm,
        'text_box': textBox,
        'color_picker': colorPicker,
        'item_list': itemList,
        'number_input': numberInput,
        'channel_dis': channelDis,
        'upload_image': uploadImage,
        'tree_list': treeList,
        'json_editor': jsonEditor
    },
    methods: {
        getFieldRes() {
            let res = [];
            let isValidate = true;
            _.map(this.$refs, (f, key) => {
                if (key.search('field_') !== -1) {
                    let resField = null;
                    if (f[0] && typeof f[0].getResField === 'function') {
                        resField = f[0].getResField();
                        if (resField) {
                            res.push(resField);
                        } else {
                            isValidate = false;
                        }
                    }
                }
            });
            if (!isValidate) {
                return false;
            }

            return res;
        },
        initData(data) {
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {

    }
}
</script>
<style lang="less" scoped>
    .field-item-wrap {
        border: 1px solid #ddd;
        background-color: #efefef;
        padding: 10px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/customForm.vue